import { Component, Input } from '@angular/core';
import { MatRadioButton } from '@angular/material/radio';
import { TpaPerson } from 'src/app/features/tpa/models/tpa-person.model';
import { DateOnlyPipe } from "../../../../../../shared/pipes/date-only.pipe";
import { MatExpansionPanel, MatExpansionPanelDescription, MatExpansionPanelHeader, MatExpansionPanelTitle } from "@angular/material/expansion";
import { MatList, MatListItem } from "@angular/material/list";

@Component({
  selector: 'app-person-selection-item',
  standalone: true,
  imports: [MatRadioButton, DateOnlyPipe, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle, MatExpansionPanelDescription, MatList, MatListItem],
  templateUrl: './person-selection-item.component.html',
  styleUrl: './person-selection-item.component.scss'
})
export class PersonSelectionItemComponent {
  @Input() person!: TpaPerson;

}
